export enum ToastVariants {
    SUCCESS = "success",
    ERROR = "error",
}
